
<template>
  <div class="home-money">
    <el-card>
      <div>
        <span class="moneyTitle">{{tit3}}</span>
        <span class="moneyDes">单位：万元</span>
      </div>
      <div class="mt10 mb6 mMiddle">
        <el-row>
          <el-col :span="10" class="nowrap">
            <span class="date">今：</span>
            <span class="allMoney">{{myChildNow.cost}}</span>
          </el-col>
          <el-col :span="14">
              <el-row>
                  <el-col :span="12" class="nowrap">
                      <span class="inlineA">环</span>
                      <span class="inlineB">{{myChildNow.ring|absVal}}</span>
                  </el-col>
                  <el-col :span="12" class="nowrap">
                      <span class="inlineD">
                  <span
                      v-if="ringRateNow===0"
                      class="inlineC"
                  >{{myChildNow.ring_rate}}</span>
                  <span v-else>
                    <span v-if="ringRateNow<0">
                      <span class="inlineC classRed">{{myChildNow.ring_rate|absVal}}</span>

                      <i class="el-icon-bottom classRed"></i>
                    </span>
                    <span v-else-if="ringRateNow>0">
                      <span class="inlineC classGreen">{{myChildNow.ring_rate}}</span>
                      <i class="el-icon-top classGreen"></i>
                    </span>
                  </span>
                </span>
                  </el-col>
              </el-row>
              <el-row>
                  <el-col :span="12" class="nowrap">
                      <span class="inlineA">同</span>
                      <span class="inlineB">{{myChildNow.same|absVal}}</span>
                  </el-col>
                  <el-col :span="12" class="nowrap">
                      <span class="inlineD">
                  <span
                      v-if="sameRateNow===0"
                      class="inlineC"
                  >{{myChildNow.same_rate}}</span>
                  <span v-else>
                    <span v-if="sameRateNow<0">
                      <span class="inlineC classRed">{{myChildNow.same_rate|absVal}}</span>

                      <i class="el-icon-bottom classRed"></i>
                    </span>
                    <span v-else-if="sameRateNow>0">
                      <span class="inlineC classGreen">{{myChildNow.same_rate}}</span>
                      <i class="el-icon-top classGreen"></i>
                    </span>
                  </span>
                </span>
                  </el-col>
              </el-row>
          </el-col>
        </el-row>
      </div>
      <el-divider class="split-line"></el-divider>
      <div class="mt6 mMiddle">
        <el-row>
          <el-col :span="10" class="nowrap">
            <span class="date">昨：</span>
            <span class="allMoney">{{myChildYesterday['cost']}}</span>
          </el-col>
          <el-col :span="14">
              <el-row>
                  <el-col :span="12" class="nowrap">
                      <span class="inlineA">环</span>
                      <span class="inlineB">{{myChildYesterday.ring}}</span>
                  </el-col>
                  <el-col :span="12" class="nowrap">
                      <span class="inlineD">
                  <span
                      v-if="ringRateYesterday===0"
                      class="inlineC"
                  >{{myChildYesterday.ring_rate}}</span>
                  <span v-else>
                    <span v-if="ringRateYesterday<0">
                      <span class="inlineC classRed">{{myChildYesterday.ring_rate|absVal}}</span>

                      <i class="el-icon-bottom classRed"></i>
                    </span>
                    <span v-else-if="ringRateYesterday>0">
                      <span class="inlineC classGreen">{{myChildYesterday.ring_rate}}</span>
                      <i class="el-icon-top classGreen"></i>
                    </span>
                  </span>
                </span>
                  </el-col>
              </el-row>
              <el-row>
                  <el-col :span="12" class="nowrap">
                      <span class="inlineA">同</span>
                      <span class="inlineB">{{myChildYesterday.same}}</span>
                  </el-col>
                  <el-col :span="12" class="nowrap">
                      <span  class="inlineD">
                  <span
                      v-if="sameRateYesterday===0"
                      class="inlineC"
                  >{{myChildYesterday.same_rate}}</span>
                  <span v-else>
                    <span v-if="sameRateYesterday<0">
                      <span class="inlineC classRed">{{myChildYesterday.same_rate|absVal}}</span>

                      <i class="el-icon-bottom classRed"></i>
                    </span>
                    <span v-else-if="sameRateYesterday>0">
                      <span class="inlineC classGreen">{{myChildYesterday.same_rate}}</span>
                      <i class="el-icon-top classGreen"></i>
                    </span>
                  </span>
                </span>
                  </el-col>
              </el-row>
          </el-col>
        </el-row>
      </div>

      <div class="chartClass">
        <div :id="chartNum" class="full-w full-h"></div>
      </div>
    </el-card>
  </div>
</template>

<script>

    import { mapState } from 'vuex';
    import dayjs from 'dayjs';
import * as echarts from "echarts";


export default {
  name: "Money",
  components: {
    // Layout,
  },
  props: {
    tit3: {
      type: String,
      default: ""
    },
    myChildNow: {
      type: Object,
      default() {
        return {
          cost: "",
          ring: "",
          same: "",
          ring_rate: "",
          same_rate: ""
        };
      }
    },
    myChildYesterday: {
      type: Object,
      default() {
        return {
          cost: "",
          ring: "",
          same: "",
          ring_rate: "",
          same_rate: ""
        };
      }
    },
    myChildChart: {
      type: Object,
      default() {
        return {
          line: [],
          date: []
        };
      }
    },
    chartNum: {
      type: String,
      default: "myChart1"
    }
  },
  data() {
    return {
      childChart: {
        el: this.chartNum,
        title: this.tit3,
        series_name: this.tit3,
        radius: "60%",
        date: this.myChildChart.date,
        line: this.myChildChart.line
      },
      moneyActiveName: "all",
      value: new Date(),
      curDate: new Date(),
      dateTimer: null,
        costChart:null,
    };
  },
    filters:{
        absVal(val){
            if(val==='--') return val;
            if(!val) return '';
            return (val+'').replace(/^-/,'');
        }
    },
  computed: {
      ringRateNow(){
        return parseFloat(this.myChildNow.ring_rate);
      },
      sameRateNow(){
          return parseFloat(this.myChildNow.same_rate);
      },
      ringRateYesterday(){
          return parseFloat(this.myChildYesterday.ring_rate);
      },
      sameRateYesterday(){
          return parseFloat(this.myChildYesterday.same_rate);
      },
      ...mapState({
          sidebarOpened:state => state.app.sidebar.opened,
      }),
  },
  created() {},
  mounted() {
      window.addEventListener("resize", this.resizeChart);
  },

  methods: {
      initChart(){
          this.drawPie3(
            this.chartNum,
            this.childChart.title,
            this.childChart.series_name,
            this.childChart.radius,
            this.myChildChart.date,
            this.myChildChart.line
          );
      },
    // 堆叠图
    drawPie3(el, title, series_name, radius, date=[], line=[]) {
          if(!this.costChart){
              this.costChart = echarts.init(document.getElementById(el));
          }

      let option = {};
      if (line.length == 0) {
        // 暂无数据
        option = {
          title: {
            text: "数据正在飞奔回来！",
            x: "center",
            y: "bottom",
            textStyle: {
              fontSize: 14,
              fontWeight: "normal"
            }
          }
        };
      } else {
          option = {
              color: ["#6ccbf4"],
              title: {},
              tooltip: {
                  trigger: 'axis',
                  formatter:'{b}<br />{c0}万元',
                  appendToBody:true,
              },
              legend: false,
              grid: {
                  top: "1%",
                  left: "1%",
                  right: "1%",
                  bottom: "0",
                  containLabel: false
              },
              xAxis: [
                  {
                      type: "category",
                      boundaryGap: false,
                      axisTick: {
                          //关键设置，坐标轴刻度也不显示
                          show: false
                      },
                      splitLine: {
                          // 拆分线条， 是否显示图表内的纵线
                          show: false
                      },

                      axisLabel: { show: false },
                      axisLine: {
                          //关键设置，不显示X轴线条
                          show: false
                      },
                      data: date.map(item=>{
                          return dayjs(item).format('MM月DD日')
                      })
                  }
              ],
              yAxis: [
                  {
                      splitLine: {
                          // 拆分线条， 是否显示图表内的纵线
                          show: false
                      },
                      axisTick: {
                          show: false
                      },
                      axisLabel: {
                          show: false
                      },
                      axisLine: {
                          lineStyle: {
                              color: "#fff",
                              width: 1 //这里是为了突出显示加上的
                          }
                      }
                  }
              ],
              series: [
                  {
                      type: "line",
                      smooth: true,
                      showSymbol: false,
                      emphasis: {
                          focus: "series"
                      },
                      symbol: "none",
                      areaStyle: {
                          color:{
                              type: 'linear',
                              x: 0,
                              y: 0,
                              x2: 0,
                              y2: 1,
                              colorStops: [{
                                  offset: 0, color: '#47b7e7' // 0% 处的颜色
                              }, {
                                  offset: 1, color: '#def3fc' // 100% 处的颜色
                              }],
                          }
                      },
                      lineStyle:{
                          width:1,
                      },
                      data: line
                  }
              ]
          };

      }

      // 二次加载重新绘制图
      document.getElementById(el).removeAttribute("_echarts_instance_");
      // 兼容  清空数据
        this.costChart.clear();
       // 数据重绘
        this.costChart.setOption(option, true);
      //  缩放浏览器重新渲染
    },
      resizeChart(){
          if(this.costChart ){
              this.costChart.resize();
          }
      }
  },
    watch:{
        sidebarOpened(){
            setTimeout(()=>{
                this.resizeChart();
            },200);
        },
    },
    beforeDestroy(){
        // 组件销毁之前必须先销毁ECharts实例,否则charts里的tooltip将阴魂不散
        if(this.costChart){
            this.costChart.dispose();
        }

        window.removeEventListener("resize", this.resizeChart);
    },
};
</script>

<style scoped lang="scss">
.chartClass {
  height: 50px;
}
.classGreen {
  font-size: 12px;
  color: #4b7902;
  text-align: right;
  font-weight: 400;
}

.classRed {
  font-size: 12px;
  color: #d9001b;
  text-align: right;
  font-weight: 400;
}

.class3 {
  color: #7f7f7f;
}

.inlineA {
  display: inline-block;
  /*width: 20px;*/
  /*text-align: left;*/
  /*font-weight: 400;*/
  /*font-style: normal;*/
  /*font-size: 12px;*/
  color: #7f7f7f;
}
.inlineB {
  display: inline-block;
  font-size: 12px;
  text-align: right;
  min-width: 50px;
    margin-right: 5px;
}
.inlineC {
  display: inline-block;
  text-align: right;
  font-size: 12px;
  min-width: 42px;
}

/*.inlineD{*/
  /*width: 60px;*/
  /*text-align: right;*/
/*}*/

.moneyTitle {
  font-size: 14px;
  font-weight: 650;
  color: #000000;
  display: inline-block;
  margin-right: 12px;
  line-height: 16px;
}
.moneyDes {
  font-size: 12px;
  color: #aaaaaa;
}
.mMiddle {
  .date {
    font-weight: 400;
    font-style: normal;
    color: #7f7f7f;
    font-size: 14px;
    
  }
  .allMoney {
    font-size: 15px;
    font-weight: 400;
    font-style: normal;
    color: #333333;
    line-height: 42px;
      display: inline-block;
      min-width: 55px;
      text-align: right;
  }
  .huan {
    /*display: flex;*/
    /*flex-direction: row;*/
    /*justify-content: space-between;*/
      /*margin-left: 6px;*/
      /*text-align: right;*/
  }
}

    .split-line{
        margin: 0;
    }
</style>
